import { useEffect, useState } from "react";
import { FileDown } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatError } from "@/lib/api";
import { waPhone } from "@/lib/whatsapp";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shares the real PDF file (Android/iPhone/tablet share sheet) or falls back to a WhatsApp message with the PDF link.
export const InviaPdfButton = ({ p, negozio }) => {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const c = p.cliente || {};
  const nomeFile = `Preventivo_${p.numero}.pdf`;
  const testo = `Ciao ${(c.nome || "").split(" ")[0]}, in allegato il preventivo di riparazione ${p.numero}${p.firma_cliente ? " firmato" : ""}.${negozio ? `\n${negozio}` : ""}`;

  useEffect(() => {
    api.get(`/preventivi/${p.id}/pdf`, { responseType: "blob" })
      .then((r) => setFile(new File([r.data], nomeFile, { type: "application/pdf" })))
      .catch(() => setFile(null));
  }, [p.id, p.updated_at, p.firma_data, nomeFile]);

  const click = async () => {
    if (file && navigator.canShare?.({ files: [file] })) {
      try {
        await navigator.share({ files: [file], title: nomeFile, text: testo });
      } catch (e) {
        if (e?.name !== "AbortError") toast.error("Condivisione non riuscita");
      }
      return;
    }
    if (!c.telefono) return toast.error("Il cliente non ha un numero di telefono");
    const w = window.open("", "_blank");
    setBusy(true);
    try {
      const { data } = await api.post("/condividi", { tipo: "preventivo", id: p.id });
      const text = `${testo.replace("in allegato il", "ecco il")}\nScarica il PDF: ${API_BASE}/pubblico/${data.token}/pdf`;
      const url = `https://wa.me/${waPhone(c.telefono)}?text=${encodeURIComponent(text)}`;
      if (w) w.location.href = url;
      else window.open(url, "_blank", "noopener");
    } catch (e) {
      if (w) w.close();
      toast.error(formatError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button variant="outline" onClick={click} disabled={busy} data-testid="preventivo-invia-pdf-button"
      className="border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 hover:text-emerald-800">
      <FileDown className="mr-1 h-4 w-4" /> Invia PDF su WhatsApp
    </Button>
  );
};
